<template>
	<notifications group="buyHive" position="top center">
    <template #body="props">
      <div class="my-notification">
        <div class="notification__body">
          <div class="border-b-4 p-5 relative rounded-lg" :class="props.item.type">
            <h2 class="font-bold">{{ props.title }}</h2>
            <div class="flex items-center justify-between">
              <div v-html="props.item.text" class="word-break"></div>
              <div
                class="absolute top-0 right-0 m-1 opacity-50 close cursor-pointer text-2xl"
                @click="close"
              >x</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </notifications>
</template>
<style lang="scss" scoped>
.vue-notification-group {
  width: 18.75rem !important;
  
  @screen md {
    width: 25rem !important;
  }
  
  .notification {
    @apply text-dark p-1 mb-1 pt-0 transition-all duration-300;
    &__body {
      @apply rounded-lg border border-dark-b shadow bg-white;
      .warn {
        border-bottom-color: #f48a06;
      }
      .error {
        border-bottom-color: #B82E24;
      }
      .success {
        border-bottom-color: #42A85F;
      }
      .word-break {
        word-break: break-word;
      }
    }
  }
}
</style>
